import { H as F, _ as de, b as me, f as ve, P as Ce, t as fe, N as ge, Q as Ae, E as we, j as Se, r as ye, l as Pe, m as De, C as xe } from "./export-cdcbfb2b.js";
import { d as Ve } from "./es.array.splice-801adf1d.js";
import { t as se } from "./to-string-92a62764.js";
import { a as Ee } from "./array-sort-7c90b530.js";
import { a as ke } from "./array-method-is-strict-e5a3c878.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.concat-d1c9b847.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.to-string-f55666a8.js";
import { QUERIES as H } from "@ucl/shared-component-foundations";
import z, { useContext as Ie, useEffect as j, useState as $e, useMemo as Ne } from "react";
import g, { css as be } from "styled-components";
import { Spinner as _e } from "./spinner.js";
import { uniqueId as M } from "./uniqueId.js";
import "./es.array.is-array-7a29277f.js";
import { C as Oe, a as $, T as Le } from "./index-f5b44da3.js";
import { TableContext as ue } from "./provider.js";
import { T as Re, A as Me } from "./tableAccordionItem-b42a40b9.js";
import { c as G } from "./index-8b07dec9.js";
import { jsx as t, jsxs as x, Fragment as ze } from "react/jsx-runtime";
import "./es.object.assign-7e79fd7b.js";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import { g as Ue } from "./es.string.replace-f4cc3aea.js";
import { A as We } from "./accordionPanel-89132988.js";
import { fordProIcons as O } from "@ucl/shared-icons";
import { useCustomTranslation as he } from "@ucl/ucl-translation";
import { useAccessibilityProps as je } from "./accessibility.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import { r as Fe } from "./es.regexp.to-string-e800d529.js";
import "./web.set-timeout-72b6430f.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import { T as D, a as He } from "./tableV1-80a39fe6.js";
import { ScreenReaderOnly as Ke } from "./screenReaderOnly.js";
import "./es.array.some-0c761b6d.js";
import { i as Be } from "./is-regexp-4c49b1c2.js";
import { isCurrency as qe } from "./currency.js";
import { d as Ge } from "./debounce-350c74b3.js";
var Qe = F, Q = Qe.match(/firefox\/(\d+)/i), Je = !!Q && +Q[1], Xe = F, Ye = /MSIE|Trident/.test(Xe), Ze = F, J = Ze.match(/AppleWebKit\/(\d+)\./), en = !!J && +J[1], nn = de, pe = me, an = Ce, tn = fe, X = ge, on = Ve, Y = se, K = ve, rn = Ee, ln = ke, Z = Je, cn = Ye, ee = Ae, ne = en, E = [], ae = pe(E.sort), dn = pe(E.push), mn = K(function() {
  E.sort(void 0);
}), sn = K(function() {
  E.sort(null);
}), bn = ln("sort"), Te = !K(function() {
  if (ee)
    return ee < 70;
  if (!(Z && Z > 3)) {
    if (cn)
      return !0;
    if (ne)
      return ne < 603;
    var e = "", n, a, m, o;
    for (n = 65; n < 76; n++) {
      switch (a = String.fromCharCode(n), n) {
        case 66:
        case 69:
        case 70:
        case 72:
          m = 3;
          break;
        case 68:
        case 71:
          m = 4;
          break;
        default:
          m = 2;
      }
      for (o = 0; o < 47; o++)
        E.push({ k: a + o, v: m });
    }
    for (E.sort(function(b, r) {
      return r.v - b.v;
    }), o = 0; o < E.length; o++)
      a = E[o].k.charAt(0), e.charAt(e.length - 1) !== a && (e += a);
    return e !== "DGBEFHACIJK";
  }
}), un = mn || !sn || !bn || !Te, hn = function(e) {
  return function(n, a) {
    return a === void 0 ? -1 : n === void 0 ? 1 : e !== void 0 ? +e(n, a) || 0 : Y(n) > Y(a) ? 1 : -1;
  };
};
nn({ target: "Array", proto: !0, forced: un }, {
  sort: function(n) {
    n !== void 0 && an(n);
    var a = tn(this);
    if (Te)
      return n === void 0 ? ae(a) : ae(a, n);
    var m = [], o = X(a), b, r;
    for (r = 0; r < o; r++)
      r in a && dn(m, a[r]);
    for (rn(m, hn(n)), b = X(m), r = 0; r < b; )
      a[r] = m[r++];
    for (; r < o; )
      on(a, r++);
    return a;
  }
});
var pn = /* @__PURE__ */ g(Re).withConfig({
  displayName: "tAccordionData__TableAccordionData",
  componentId: "e8ft84-0"
})(["", ""], function(e) {
  return `
 border-radius: ` + e.theme.components.dataTable.TableAccordionData.borderRadius + `;
 && > div {
    align-items: ` + e.theme.components.dataTable.TableAccordionData.div.alignItems + `;
    width: ` + e.theme.components.dataTable.TableAccordionData.div.width + `;
    border-top: ` + e.theme.components.dataTable.TableAccordionData.div.borderTop + `;
    border-bottom: ` + e.theme.components.dataTable.TableAccordionData.div.borderBottom + `;
    border-radius: ` + e.theme.components.dataTable.TableAccordionData.div.borderRadius + `;
 }
  @media ` + H.tabletAndUp + ` {
    display: ` + e.theme.components.dataTable.TableAccordionData.div.tabletView.display + `;
  }
  border-top: ` + e.theme.components.dataTable.TableAccordionData.borderTop + `;
  border-bottom: ` + e.theme.components.dataTable.TableAccordionData.borderBottom + `;
    `;
}), Tn = /* @__PURE__ */ g(Me).withConfig({
  displayName: "tAccordionItemData__TableAccordionItemData",
  componentId: "sc-1u1i73o-0"
})(["", ""], function(e) {
  return `
    && span.CheckBox__checkmark-container {
      left: ` + e.theme.components.dataTable.TableAccordionItemData.checkBoxSpan.left + `;
      top: ` + e.theme.components.dataTable.TableAccordionItemData.checkBoxSpan.top + `;
    }
    background: ` + (e.$background ? e.theme.components.dataTable.TableAccordionItemData.backgroundColor.isBackground : e.theme.components.dataTable.TableAccordionItemData.backgroundColor.none) + `;
    border-radius: ` + e.theme.components.dataTable.TableAccordionItemData.borderRadius + `;
    padding: ` + e.theme.components.dataTable.TableAccordionItemData.padding + `;
    && > div {
      padding-left: ` + e.theme.components.dataTable.TableAccordionItemData["&& > div"].paddingLeft + `;
    }
    [data-component='accordion-dropdown-wrapper'] {
      color: ` + e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-dropdown-wrapper"]'].color + `;
    }
    [data-component='accordion-title-wrapper'] {
      height: ` + e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].height + `;
      font-family: ` + e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontSize + `;
      font-style: ` + e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontStyle + `;
      font-weight: ` + e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontWeight + `;
      line-height: ` + e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].lineHeight + `;
    }
    ` + (e.$showcheckboxenabled ? `[data-component="accordion-icon-wrapper"]{

          }
        ` : "") + `
    `;
}), vn = /* @__PURE__ */ g.div.withConfig({
  displayName: "tAccordionPanelContent__TableAccordionPanelContentContainer",
  componentId: "sc-2ivixw-0"
})(["", ""], function(e) {
  return `
    display: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.display + `;;
    flex-direction: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.flexDirection + `;
    align-items: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.alignItems + `;
    gap: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.gap + `;
    align-self: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.alignSelf + `;
    `;
}), te = /* @__PURE__ */ g.div.withConfig({
  displayName: "tAccordionPanelContent__TableAccordionPanelContentData",
  componentId: "sc-2ivixw-1"
})(["", ""], function(e) {
  return `
    display: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.display + `;
    flex-direction: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.flexDirection + `;
    align-items: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.alignItems + `;
    gap: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.gap + `;
   && > div {
      gap: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.div.gap + `;
      align-items: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.div.alignItems + `;
    }
    align-self: ` + e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.alignSelf + `;
    `;
}), Cn = /* @__PURE__ */ g(We).withConfig({
  displayName: "tAccordionPanelData__TableAccordionPanelData",
  componentId: "sc-1j5oz6-0"
})(["", ""], function(e) {
  return `
    width: ` + e.theme.components.dataTable.TableAccordionPanelData.width + `;
    height: ` + e.theme.components.dataTable.TableAccordionPanelData.height + `;
    justify-content: ` + e.theme.components.dataTable.TableAccordionPanelData.justifyContent + `;
    margin: ` + e.theme.components.dataTable.TableAccordionPanelData.margin + `;
    padding: ` + e.theme.components.dataTable.TableAccordionPanelData.padding + `;
    && > div {
      color: ` + e.theme.components.dataTable.TableAccordionPanelData["&& > div"].color + `;
      font-family: ` + e.theme.components.dataTable.TableAccordionPanelData["&& > div"].fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableAccordionPanelData["&& > div"].fontSize + `;
      letter-spacing: ` + e.theme.components.dataTable.TableAccordionPanelData["&& > div"].letterSpacing + `;
      line-height: ` + e.theme.components.dataTable.TableAccordionPanelData["&& > div"].lineHeight + `;
    }
    `;
}), fn = function(n) {
  var a = n.content, m = n.title, o = n.rowElementIndex, b = n.id, r = n.backgroundColor, u = n.DropDownComponent, h = n.$checkboxProps, C = z.useContext(ue), i = C.checkboxCheckedValues, s = C.setCheckboxChecked, p = C.showOptionsEnabled, T = C.showCheckboxEnabled, d = i == null ? void 0 : i.find(function(A) {
    return A.id === b;
  });
  return /* @__PURE__ */ t(pn, {
    "data-component": "accordion-data",
    children: /* @__PURE__ */ t(Tn, {
      title: m,
      id: "" + o,
      $showcheckboxenabled: T,
      $background: r,
      isIconOnClickEnabled: !1,
      isDropDownMenu: p,
      DropDownComponent: u,
      isAnimate: !1,
      icon: T && /* @__PURE__ */ t(Oe, {
        checkboxValue: (h == null ? void 0 : h.value) || (d == null ? void 0 : d.value),
        onChange: function(y) {
          s && s(b, ((d == null ? void 0 : d.value) === $.UNCHECKED || (d == null ? void 0 : d.value) === void 0) && $.CHECKED || $.UNCHECKED), h && h.onClick && h.onClick(y, b, ((d == null ? void 0 : d.value) === $.UNCHECKED || (d == null ? void 0 : d.value) === void 0) && $.CHECKED || $.UNCHECKED);
        },
        disabled: (h == null ? void 0 : h.disabled) || (d == null ? void 0 : d.disabled)
      }) || "",
      children: /* @__PURE__ */ t(Cn, {
        children: /* @__PURE__ */ t(vn, {
          children: a
        })
      })
    })
  });
}, gn = O.ArrowDown, An = O.ArrowUp, wn = O.Sorting, Sn = /* @__PURE__ */ g.button.withConfig({
  displayName: "tableSortingView__Wrapper",
  componentId: "f0et3q-0"
})(["", ""], function(e) {
  return `
    border-color: ` + e.theme.components.dataTable.TableSortingView.Wrapper.borderColor + `;
    background-color: ` + e.theme.components.dataTable.TableSortingView.Wrapper.backgroundColor + `;
    color: ` + e.theme.components.dataTable.TableSortingView.Wrapper.color + `;
    `;
}), yn = function(n) {
  var a = n.rowValues, m = n.setRowValues, o = n.columnNumber, b = n.onClick, r = n.setSortingEnabled, u = n.columnName, h = n.accessibilityOptions, C = Ie(ue), i = C.sortOrder, s = C.setSortOrder, p = he("DataTable"), T = p.t;
  j(function() {
    r(!0);
  }, []);
  var d = function() {
    var V = {
      columnNumber: o,
      value: (i == null ? void 0 : i.value) === "asc" ? "desc" : "asc"
    };
    s(V), m(a, V);
  }, A = je("button", Object.assign({
    ariaLabel: i.columnNumber === o && (i == null ? void 0 : i.value) === "asc" && T("Sort column", "tableSortPrefix") + " " + u + " " + T("Sort column", "tableSortAscendingSuffix") || i.columnNumber === o && (i == null ? void 0 : i.value) === "desc" && T("Sort column", "tableSortPrefix") + " " + u + " " + T("Sort column", "tableSortDescendingSuffix") || T("Sort column", "tableSortPrefix") + " " + u + " " + T("Sort column", "tableSortDefaultSuffix")
  }, h));
  return /* @__PURE__ */ t(Sn, Object.assign({
    onClick: function(V) {
      V.preventDefault(), d(), b && b(V, (i == null ? void 0 : i.value) === "asc" ? "desc" : "asc");
    }
  }, A, {
    children: i.columnNumber === o && (i == null ? void 0 : i.value) === "asc" && /* @__PURE__ */ t(An, {
      size: "s"
    }) || i.columnNumber === o && (i == null ? void 0 : i.value) === "desc" && /* @__PURE__ */ t(gn, {
      size: "s"
    }) || /* @__PURE__ */ t(wn, {
      size: "s"
    })
  }));
}, oe = /* @__PURE__ */ g.div.withConfig({
  displayName: "tAccordionPanelContentColumnData__TableAccordionPanelContentColumnData",
  componentId: "sc-7bipal-0"
})(["", ""], function(e) {
  return `
    color: ` + e.theme.components.dataTable.TableAccordionPanelContentColumnData.color + `;
    font-family: ` + e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontFamily + `;
    font-size: ` + e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontSize + `;
    font-style: ` + e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontStyle + `;
    font-weight: ` + e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontWeight + `;
    line-height: ` + e.theme.components.dataTable.TableAccordionPanelContentColumnData.lineHeight + `;

    `;
}), re = /* @__PURE__ */ g.div.withConfig({
  displayName: "tAccordionPanelContentTableData__TableAccordionPanelContentTableData",
  componentId: "sc-1sk8zbz-0"
})(["", ""], function(e) {
  return `
    && > :not(button) {
      color: ` + e.theme.components.dataTable.TableAccordionPanelContentTableData.color + `;
      font-family: ` + e.theme.components.dataTable.TableAccordionPanelContentTableData.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableAccordionPanelContentTableData.fontSize + `;
      font-style: ` + e.theme.components.dataTable.TableAccordionPanelContentTableData.fontStyle + `;
      font-weight: ` + e.theme.components.dataTable.TableAccordionPanelContentTableData.fontWeight + `;
      line-height: ` + e.theme.components.dataTable.TableAccordionPanelContentTableData.lineHeight + `;
    }
    `;
}), Pn = /* @__PURE__ */ g.div.withConfig({
  displayName: "tableEmptyView__TableEmptyViewWrapper",
  componentId: "sc-1yjt7p-0"
})(["&.TableEmptyView-wrapper{", ";}"], function(e) {
  var n = e.theme.components.dataTable;
  return be(n.TableEmptyViewWrapper);
}), Dn = /* @__PURE__ */ g.div.withConfig({
  displayName: "tableEmptyView__TableEmptyViewContainer",
  componentId: "sc-1yjt7p-1"
})(["&.TableEmptyViewContainer-container{", ";}"], function(e) {
  var n = e.theme.components.dataTable;
  return be(n.TableEmptyViewContainer);
}), ie = function(n) {
  var a = n.children, m = n.isMarketingTable, o = m === void 0 ? !1 : m, b = n.isMobile;
  return /* @__PURE__ */ t(Dn, {
    className: G(["TableEmptyViewContainer-container"]),
    "aria-live": "polite",
    children: /* @__PURE__ */ x(Pn, {
      "aria-live": "polite",
      className: G(["TableEmptyView-wrapper", {
        "TableEmptyView-wrapper--marketingTable": o
      }, {
        "TableEmptyView-wrapper--mobile": b
      }]),
      children: [/* @__PURE__ */ t(Ke, {
        role: "alert",
        children: a
      }), a]
    })
  });
}, U = /* @__PURE__ */ g.div.withConfig({
  displayName: "mobileTableView__LeadingTrailingIconWrapper",
  componentId: "sc-1vzllur-0"
})(["display:flex;align-items:center;@media ", "{margin:auto 0;&& > div{align-items:center;}}"], H.tabletAndUp), xn = /* @__PURE__ */ g.div.withConfig({
  displayName: "mobileTableView__CellContentAndDescriptionWrapper",
  componentId: "sc-1vzllur-1"
})(["@media ", "{display:flex;flex-direction:column;}"], H.tabletAndUp), Na = function(n) {
  var a, m, o, b, r, u, h, C, i, s = n.headerValues, p = n.rowValues, T = p === void 0 ? [] : p, d = n.headerCheckboxProps, A = n.setRowValues, y = n.emptyTableMessage, V = n.setSortingEnabled, N = n.showLoader, k = s.map(function(l, P) {
    return /* @__PURE__ */ x(D.CellContent, {
      children: [l.leadingComponents, l.textValue && /* @__PURE__ */ t(D.CellContentText, {
        contentAlignment: l.contentAlignment,
        children: l.textValue
      }), l.trailingComponents]
    }, P);
  }), L = /* @__PURE__ */ t(He, {
    $checkboxProps: d,
    children: /* @__PURE__ */ x(D.Header, {
      style: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
      },
      children: [/* @__PURE__ */ x(D.CellContent, {
        children: [(a = s[0]) == null ? void 0 : a.leadingComponents, ((m = s[0]) == null ? void 0 : m.textValue) && /* @__PURE__ */ t(D.CellContentText, {
          contentAlignment: (o = s[0]) == null ? void 0 : o.contentAlignment,
          children: (b = s[0]) == null ? void 0 : b.textValue
        }), (r = s[0]) == null ? void 0 : r.trailingComponents]
      }), ((u = s[0]) == null || (u = u.sortingProp) == null ? void 0 : u.isSortingEnabled) && /* @__PURE__ */ t(yn, {
        setSortingEnabled: V,
        rowValues: T,
        setRowValues: function() {
          for (var P, v = arguments.length, w = new Array(v), c = 0; c < v; c++)
            w[c] = arguments[c];
          return A.apply(void 0, w.concat([(P = s[0]) == null || (P = P.sortingProp) == null ? void 0 : P.comparator]));
        },
        columnNumber: 0,
        columnName: ((h = s[0]) == null ? void 0 : h.textValue) || ((C = s[0]) == null ? void 0 : C.columnAlternateText) || "",
        onClick: (i = s[0]) == null || (i = i.sortingProp) == null ? void 0 : i.onClick
      })]
    })
  }, M("thead")), f = [];
  return f.push(L), !N && T.length > 0 ? T.forEach(function(l, P) {
    var v, w;
    l.cellData.forEach(function(c, S) {
      var I = /* @__PURE__ */ x(D.Cell, {
        $contentAlignment: s[S].contentAlignment || "center",
        id: c.id,
        children: [c.leadingComponents && /* @__PURE__ */ t(U, {
          children: c.leadingComponents
        }), /* @__PURE__ */ x(xn, {
          children: [/* @__PURE__ */ x(D.CellContent, {
            children: [c.textValue && /* @__PURE__ */ t(D.CellContentText, {
              contentAlignment: s[S].contentAlignment || "center",
              children: c.textValue
            }), c.trailingComponents && !c.textValue && /* @__PURE__ */ t(U, {
              children: c.trailingComponents
            })]
          }), c.description && /* @__PURE__ */ t(D.CellDescription, {
            children: c.description
          }), (c == null ? void 0 : c.secondaryDescription) && /* @__PURE__ */ t(D.CellDescription, {
            children: c == null ? void 0 : c.secondaryDescription
          })]
        }), c.trailingComponents && c.textValue && /* @__PURE__ */ t(U, {
          children: c.trailingComponents
        })]
      }, (c.id || S) + "_0_" + M("table_cell"));
      S === 0 ? v = I : /* @__PURE__ */ z.isValidElement(w) ? w = /* @__PURE__ */ x(ze, {
        children: [w, /* @__PURE__ */ x(te, {
          children: [/* @__PURE__ */ t(oe, {
            className: "label",
            children: k[S]
          }), /* @__PURE__ */ t(re, {
            children: I
          })]
        }, (c.id || S) + "_0_" + M("table_cell"))]
      }) : w = /* @__PURE__ */ x(te, {
        children: [/* @__PURE__ */ t(oe, {
          className: "label",
          children: k[S]
        }), /* @__PURE__ */ t(re, {
          children: I
        })]
      }, (c.id || S) + "_0_" + M("table_cell"));
    }), f.push(/* @__PURE__ */ t(fn, {
      content: w,
      title: v,
      rowElementIndex: P,
      id: l.rowId,
      $checkboxProps: l.checkboxProps,
      DropDownComponent: l.DropDownComponent
    }));
  }) : N ? f.push(/* @__PURE__ */ t(ie, {
    isMobile: !0,
    children: /* @__PURE__ */ t(_e, {
      size: "medium"
    })
  })) : f.push(/* @__PURE__ */ t(ie, {
    isMobile: !0,
    children: y || ""
  })), f;
}, Vn = de, En = Se, B = me, le = ye, kn = xe, In = Pe, $n = Be, _ = se, Nn = De, _n = Fe, On = Ue, Ln = we, Rn = Ln("replace"), Mn = TypeError, W = B("".indexOf);
B("".replace);
var ce = B("".slice), zn = Math.max;
Vn({ target: "String", proto: !0 }, {
  replaceAll: function(n, a) {
    var m = le(this), o, b, r, u, h, C, i, s, p, T, d = 0, A = "";
    if (!In(n)) {
      if (o = $n(n), o && (b = _(le(_n(n))), !~W(b, "g")))
        throw new Mn("`.replaceAll` does not allow non-global regexes");
      if (r = Nn(n, Rn), r)
        return En(r, n, m, a);
    }
    for (u = _(m), h = _(n), C = kn(a), C || (a = _(a)), i = h.length, s = zn(1, i), p = W(u, h); p !== -1; )
      T = C ? _(a(h, p, u)) : On(h, u, p, [], void 0, a), A += ce(u, d, p) + T, d = p + i, p = p + s > u.length ? -1 : W(u, h, p + s);
    return d < u.length && (A += ce(u, d)), A;
  }
});
var Un = O.Clear, Wn = O.Search, jn = /* @__PURE__ */ g.div.withConfig({
  displayName: "tableSearchView__Container",
  componentId: "gwl6o4-0"
})(["", ""], function(e) {
  return `
  width: ` + e.theme.components.dataTable.TableSearchView.Container.width + `;
  max-width: ` + e.theme.components.dataTable.TableSearchView.Container.maxWidth + `
  `;
}), Fn = function(n) {
  var a = n.setRowValues, m = n.rowValues, o = n.searchValue, b = n.setSearchValue, r = n.searchPlaceholder, u = n.onSearch, h = n.onClear, C = n.setSearchEnabled, i = n.isStatic, s = $e(""), p = s[0], T = s[1], d = z.useRef(null), A = he("DataTable"), y = A.t, V = !!p.length, N = Ne(function() {
    return !!p.length;
  }, [V]);
  j(function() {
    C(N);
  }, [N]), j(function() {
    o && (T(o), k(o));
  }, [m, o]);
  var k = Ge(function(f) {
    if (!(i && u))
      if (f === "")
        a(m);
      else {
        var l = m.filter(function(P) {
          return P.cellData.some(function(v) {
            var w, c, S, I = (v == null || (w = v.textValue) == null ? void 0 : w.toLowerCase().includes(f.toLowerCase())) || (v == null || (c = v.cellAltText) == null ? void 0 : c.toLowerCase().includes(f.toLowerCase())) || typeof (v == null ? void 0 : v.description) == "string" && (v == null || (S = v.description) == null ? void 0 : S.toLowerCase().includes(f.toLowerCase()));
            if (!I && qe((v == null ? void 0 : v.textValue) || "")) {
              var R, q = v == null || (R = v.textValue) == null || (R = R.toLowerCase()) == null ? void 0 : R.replaceAll(",", "");
              return q == null ? void 0 : q.includes(f.toLowerCase());
            }
            return I;
          });
        });
        a(l);
      }
  }, 300), L = function(l) {
    d && d.current && (d.current.click(), d.current.focus()), l.stopPropagation(), T(""), k(""), b && b(""), h && h(l);
  };
  return /* @__PURE__ */ t(jn, {
    children: /* @__PURE__ */ t(Le, {
      inputRef: d,
      "aria-label": y(r || "Search here", "tableSearchLabel"),
      startAdornmentProp: {
        startAdornment: /* @__PURE__ */ t(Wn, {
          tabIndex: -1,
          size: "m",
          "aria-label": y(r || "Search here", "tableSearchLabel")
        })
      },
      endAdornmentProp: {
        endAdornment: /* @__PURE__ */ t(Un, {
          tabIndex: 0,
          role: "button",
          "aria-label": y(r || "Search here", "tableSearchClearAriaLabel"),
          size: "m",
          onKeyDown: function(l) {
            (l.code === "Enter" || l.code === "Space") && (l.preventDefault(), L(l));
          },
          onClick: function(l) {
            L(l);
          }
        })
      },
      placeholder: r || y(r || "Search here", "tableSearchLabel"),
      textSize: "small",
      value: p,
      onChange: function(l) {
        T(l.target.value), k(l.target.value), b && b(l.target.value);
      },
      onKeyUp: function(l) {
        u && u(l, p);
      }
    })
  });
};
const _a = /* @__PURE__ */ z.memo(Fn);
export {
  xn as C,
  U as L,
  Na as M,
  _a as T,
  yn as a,
  ie as b
};
